import { useMediaQuery } from "@mui/material";

// Note that the breakpoints in this file need to be coordinated with the screens in tailwind.config.js.

export const useIsSmallScreen = () => useMediaQuery("@media (min-width:600px)");
export const useIsMediumScreen = () => useMediaQuery("@media (min-width:905px)");
export const useIsLargeScreen = () => useMediaQuery("@media (min-width:1240px)");
export const useIsExtraLargeScreen = () => useMediaQuery("@media (min-width:1440px)");
